<template>
  <div>
    <!--Loading-->
    <b-loading :is-full-page="true" :active.sync="isLoading"></b-loading>

    <PageTitle title="Picture Library" />
    <div class="card">
      <div class="card-content">
        <div class="columns is-centered">
          <div class="column is-5 has-text-centered">
            <b-field>
              <b-input placeholder="Add a name for this image" v-model="picture_library.name"></b-input>
            </b-field>
            <b-field>
              <b-upload v-model="picture_library.file" drag-drop expanded accept="image/*">
                <section class="section">
                  <div class="content has-text-centered">
                    <p><b-icon icon="upload" size="is-large"></b-icon></p>
                    <p>Drop your files here or click to upload</p>
                  </div>
                </section>
              </b-upload>
            </b-field>

            <p class="mb-2"><span v-if="picture_library.file" class="tag is-primary">{{picture_library.file.name}}</span></p>

            <b-button @click="proceed()" type="is-primary">Save</b-button>

          </div>
        </div>

        <!-- Pagination Controls -->
        <div class="columns" v-if="fetchPictureLibraries.length > 0">
          <div class="column is-9">
            <b-pagination
              :total="fetchPictureLibraries.length"
              v-model="current_picture_page"
              :per-page="picture_page_items"
              aria-next-label="Next page"
              aria-previous-label="Previous page"
              aria-page-label="Page"
              aria-current-label="Current page"
            >
            </b-pagination>
          </div>
          <div class="column is-3">
            <b-numberinput
              v-model="current_picture_page"
              :controls="false"
              placeholder="Page number"
            ></b-numberinput>
          </div>
        </div>

        <!-- Picture Library Grid with Pagination -->
        <div class="columns is-multiline">
          <div v-for="pl in currentPagePictureLibraries" :key="pl._id" style="position: relative;" class="column is-3">
            <div class="p-2" style="border: 1px solid #ccc">
              <span class="hover-allow" style="position: absolute;right: 10px;z-index: 9" @click="deletethisClipart(pl._id)"><b-icon icon="delete"></b-icon></span>
              <p class="title has-text-centered is-6">{{pl.name}}</p>
              <show-image :src="pl.file" /> 
            </div>
          </div>
        </div>

        <!-- Show message when no picture libraries on current page -->
        <div v-if="currentPagePictureLibraries.length === 0 && fetchPictureLibraries.length > 0" class="has-text-centered">
          <p class="title is-5">No picture libraries found on this page</p>
          <p class="subtitle is-6">Try navigating to a different page</p>
        </div>

        <!-- Show message when no picture libraries exist -->
        <div v-if="fetchPictureLibraries.length === 0 && !isLoading" class="has-text-centered">
          <p class="title is-5">No picture libraries available</p>
          <p class="subtitle is-6">Upload your first picture to get started</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
//Vuex
import {mapGetters, mapActions} from 'vuex'
import PageTitle from '@/components/PageTitle'
import ShowImage from '@/components/General/ShowImage'

export default {
  name : 'PictureLibrary',
  components : {
    PageTitle,
    ShowImage
  },
  data(){
    return {
      isLoading : false,
      modalGradeActive : false,
      picture_library : {
        name : '',
        file : null
      },
      // Pagination data similar to SetQuestion.vue
      current_picture_page: 1,
      picture_page_items: 20
    }
  },
  computed : {
    ...mapGetters(['fetchPictureLibraries', 'getTeacherToken']),
    // Computed property for current page picture libraries similar to SetQuestion.vue
    currentPagePictureLibraries() {
      return this.fetchPictureLibraries.slice(
        (this.current_picture_page - 1) * this.picture_page_items,
        this.current_picture_page * this.picture_page_items
      );
    }
  },
  methods : {
    ...mapActions(['loadPictureLibraries', 'createPictureLibrary', 'deletePictureLibrary']),
    proceed(){
      if(!this.picture_library.file){
        return this.$buefy.toast.open({
          message: 'Please add an image before proceeding',
          type: 'is-danger'
        })
      }
      this.createPictureLibrary({
        token : this.getTeacherToken,
        picture_library : this.picture_library
      }).then(() => {
        this.picture_library.file = null
        this.$buefy.toast.open({
          message: 'Clipart created successfully',
          type: 'is-success'
        })
      }).catch((err) => {
        this.picture_library.file = null
        this.$buefy.toast.open({
          message: err.response.data,
          type: 'is-danger'
        })
      })
    },
    deletethisClipart(id){
      this.$buefy.dialog.confirm({
        title: 'Continue deleting this picture library',
        message : 'Are you sure want to delete this picture library permanently?',
        type : 'is-danger',
        onConfirm: () => {
          this.deletePictureLibrary({
            token : this.getTeacherToken,
            id
          }).then(() => {
            this.$buefy.toast.open({
              message: 'Clipart deleted successfully',
              type: 'is-success'
            })
          }).catch(err => {
            this.$buefy.toast.open({
              message: err.response.data,
              type: 'is-danger'
            })
          })
        }
      })
    }
  },
  async created(){
    this.isLoading = true
    try{
      await this.loadPictureLibraries({ token : this.getTeacherToken })
    }catch(err){
      this.$buefy.toast.open({
        message: err.response.data,
        type: 'is-danger'
      })
    }
    this.isLoading = false
  }
  
}
</script>